import {
  Button,
  DatePicker,
  Form,
  Input,
  InputNumber,
  message,
  Select,
  Upload,
  Radio,
} from "antd";
import React, { useEffect, useState } from "react";
import moment from "moment";
import axios from "axios";
import { useSelector } from "react-redux";
import S3UploadButton from "../../../../../components/S3UploadButton";
import { v4 as uuidv4 } from "uuid";
import dayjs from 'dayjs';
function Prescribed({
  form,
  onClose,
  data,
  UserID,
  past,
  patch,
  idPrescription,
  ConditionName,
  setFlagFetch,
  resetFlag,
}) {
  const { TextArea } = Input;
  const [additionalMeds, setAdditionalMeds] = useState([]);
  const [MedicinesList, setMedicinesList] = useState([]);
  const [fileList, setFileList] = useState([]);
  const accessToken = useSelector((state) => state.user.accessToken);
  const API_URL = import.meta.env.VITE_API_URL;
  const disabled = past == "past" ? true : false;
  const PatchMethod = patch == "patch" ? true : false;
  useEffect(() => {
    setAdditionalMeds([]);
    form.resetFields();
    // Clear any default values that might be set
    form.setFieldsValue({
      start_date: null,
      end_date: null,
      quick_end_date: null
    });
  }, [resetFlag]);
  const handleFileRemove = () => {
    setFileList([]);
  };
  const getMedicines = async () => {
    try {
      const response = await axios.get(`${API_URL}Medicines/get-medicines?limit=100000`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const MedicinesListID = response.data.medicines.map((medicines) => ({
        id: medicines.id,
        name: medicines.name,
        type: medicines.type,
        dose: medicines.dose,
      }));
      setMedicinesList(MedicinesListID);
    } catch (e) {
      message.error("Failed to fetch medicines");
    }
  };
  useEffect(() => {
    getMedicines();
  }, [patch]);
  useEffect(() => {
    getMedicines();
    if (data) {
      const startDate = data?.startDate ? dayjs(data.startDate) : null;
      const endDate = data?.endDate ? dayjs(data.endDate) : null;

      form.setFieldsValue({
        prescription_name: ConditionName,
        medicine_name: data?.medicineDetails?.name,
        quantity: data?.quantity,
        frequency: data?.frequency,
        comments: data?.comments,
        start_date: startDate,
        end_date: endDate,
        unit: data?.unit,
        amountOfDose: data?.amountOfDose,
        quantityOfBox: data?.quantityOfBox,
        timeToTake: data?.timeToTake,
        prescriptionImage: data?.prescriptionImage,
      });
    } else {
      // Set default start date to today
      form.setFieldsValue({
        start_date: moment().startOf('day')
      });
    }
  }, [data, form, resetFlag]);
  const onFinishPrescribed = async (values) => {
    try {
      console.log('Form values prescribed:', values);
      const startDate = moment(data?.createdAt);
      const EndDate = moment(data?.endDate);
      const isMainFormFilled = Object.entries(values)
        .filter(([key]) => key !== "prescription_name")
        .some(([_, v]) => v !== undefined && v !== null && v !== "");

      if (!isMainFormFilled && additionalMeds.length === 0) {
        message.error(
          "Please add at least one medication or fill out the form!"
        );
        return;
      }

      if (!values.prescription_name) {
        message.error("Prescription name is required!");
        return;
      }

      if (!values.prescriptionImage) {
        message.error("Attachments is required!");
        return;
      }

      // Set default start date if not provided
      if (!values.start_date) {
        values.start_date = moment().startOf('day');
      }
      // In your formattedData construction (POST request):
      const formattedData = {
        name: values.prescription_name,
        userId: UserID,
        prescribedMedicines: [
          ...additionalMeds.map((med) => ({
            medicineId:
              typeof med.medicine_name == "string"
                ? MedicinesList.find(
                  (medicine) => medicine.name === values.medicine_name
                )?.id || null
                : med.medicine_name,
            amountOfDose: med.amountOfDose,
            frequency: med.frequency,
            quantityOfBox: med.quantityOfBox,
            unit: med.unit,
            quantity: med.quantity,
            timeToTake: med.timeToTake,
            type: "Prescribed",
            prescriptionImage: med.prescriptionImage,
            ...(med.comments && { comments: med.comments }),
            startDate: med.start_date?.toISOString(),
            endDate: med.end_date?.toISOString(),
          })),
          ...(isMainFormFilled
            ? [
              {
                medicineId:
                  typeof values.medicine_name === "string"
                    ? MedicinesList.find(
                      (medicine) => medicine.name === values.medicine_name
                    )?.id || null
                    : values.medicine_name,
                amountOfDose: values.amountOfDose,
                frequency: values.frequency,
                quantityOfBox: values.quantityOfBox,
                unit: values.unit,
                quantity: values.quantity,
                timeToTake: values.timeToTake,
                type: "Prescribed",
                prescriptionImage: values.prescriptionImage,
                ...(values.comments && { comments: values.comments }),
                startDate: values.start_date?.toISOString(),
                endDate: values.end_date?.toISOString(),
              },
            ]
            : []),
        ],
      };

      // In your formattedPatchMedicines (PATCH request):
      const formattedPatchMedicines = {};
      if (PatchMethod) {
        console.log(values.prescriptionImage);

        const startDateForm = moment(values.start_date);
        const endDateForm = moment(values.end_date);
        if (values.medicine_name !== data?.medicineDetails?.name) {
          formattedPatchMedicines.medicineId =
            typeof values.medicine_name == "string"
              ? MedicinesList.find(
                (medicine) => medicine.name === values.medicine_name
              )?.id || null
              : values.medicine_name || null;
        }

        if (values.frequency !== data?.frequency)
          formattedPatchMedicines.frequency = values.frequency;
        if (values.quantityOfBox !== data?.quantityOfBox)
          formattedPatchMedicines.quantityOfBox = values.quantityOfBox;
        if (values.unit !== data?.unit)
          formattedPatchMedicines.unit = values.unit;
        if (values.quantity !== data?.quantity)
          formattedPatchMedicines.quantity = values.quantity;
        if (values.amountOfDose !== data?.amountOfDose)
          formattedPatchMedicines.amountOfDose = values.amountOfDose;
        if (values.timeToTake !== data?.timeToTake)
          formattedPatchMedicines.timeToTake = values.timeToTake;
        if (values.prescriptionImage !== data?.prescriptionImage)
          formattedPatchMedicines.prescriptionImage = values.prescriptionImage;
        if (values.prescriptionImage == null)
          formattedPatchMedicines.prescriptionImage = null;
        if (values.comments !== data?.comments)
          formattedPatchMedicines.comments = values.comments;
        if (!startDateForm.isSame(startDate)) {
          formattedPatchMedicines.startDate = values.start_date.toISOString();
        }

        if (!endDateForm.isSame(EndDate)) {
          formattedPatchMedicines.endDate = values.end_date.toISOString();
        }
        if (Object.keys(formattedPatchMedicines).length === 0) {
          message.info("No Change");
          onClose();
          return;
        }
      }

      const formattedPatchName = {
        name: ConditionName,
        userId: UserID,
      };

      // API request
      const response = PatchMethod
        ? await axios.patch(
          `${API_URL}Prescriptions?id=${idPrescription}`,
          formattedPatchName,
          {
            headers: { Authorization: `Bearer ${accessToken}` },
          }
        )
        : await axios.post(`${API_URL}Prescriptions`, formattedData, {
          headers: { Authorization: `Bearer ${accessToken}` },
        });
      // console.log(formattedData);
      const responseMedicines = PatchMethod
        ? await axios.patch(
          `${API_URL}Prescriptions/PrescribedMedicines?id=${data.id}`,
          formattedPatchMedicines,
          {
            headers: { Authorization: `Bearer ${accessToken}` },
          }
        )
        : null;

      // Ensure the prescriptions reload
      if (typeof setFlagFetch === "function") {
        setTimeout(() => {
          setFlagFetch((prev) => prev + 1);
        }, 100);
      } else {
        console.error("setFlagFetch is NOT a function:", setFlagFetch);
      }

      message.success("Prescription saved!");
      form.resetFields();
      setAdditionalMeds([]);
      setFileList([]);
      onClose();
    } catch (error) {
      console.error("Save failed:", error);
      message.error(error?.response?.data?.message || "Save failed!");
    }
  };
  const addAdditionalMedication = () => {
    form
      .validateFields([
        "medicine_name",
        "dose",
        "frequency",
        "quantityOfBox",
        "unit",
        "quantity",
        "amountOfDose",
        "start_date",
        "end_date",
        "prescriptionImage",
        "comments",
        "timeToTake",
      ])
      .then((values) => {
        // Check for empty required fields
        const requiredFields = [
          "medicine_name",
          "dose",
          "frequency",
          "quantityOfBox",
          "unit",
          "quantity",
          "amountOfDose",
          "start_date",
          "end_date",
          "prescriptionImage"
        ];
        const hasEmptyFields = requiredFields.some(
          (key) =>
            values[key] === undefined ||
            values[key] === null ||
            values[key] === ""
        );

        if (hasEmptyFields) {
          message.error("Please fill in all required fields before adding!");
          return;
        }

        setAdditionalMeds((prev) => [
          ...prev,
          {
            ...values,
            // Remove default empty string for prescriptionImage
            prescriptionImage: values.prescriptionImage || null,
            comments: values.comments || null,
          },
        ]);

        // Reset all fields including prescriptionImage and comments
        form.resetFields([
          "medicine_name",
          "dose",
          "frequency",
          "quantityOfBox",
          "unit",
          "quantity",
          "amountOfDose",
          "end_date",
          "prescriptionImage",
          "comments",
          "timeToTake",
        ]);
        form.setFieldsValue({
          start_date: moment().startOf('day')
        });

        setFileList([]);
      })
      .catch(() => {
        message.error(
          "Please fill all required medication fields before adding!"
        );
      });
  };

  const removeMedication = (id) => {
    setAdditionalMeds((prev) => prev.filter((med) => med.id !== id));
  };

  // Add responsive style
  const useViewport = () => {
    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
      const handleWindowResize = () => setWidth(window.innerWidth);
      window.addEventListener("resize", handleWindowResize);
      return () => window.removeEventListener("resize", handleWindowResize);
    }, []);

    return { width };
  };

  const { width } = useViewport();
  const isFullWidth = width < 1492;

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onFinishPrescribed}
      style={{
        background: "#fff",
        borderRadius: "8px",
      }}
    >
      <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
        {/* Row 1 */}
        <div style={{ display: "flex", gap: "8px", alignItems: "flex-end", flex: "1 1 calc(50% - 8px)", minWidth: "300px" }}>
          <Form.Item
            label="Specialty"
            name="prescription_name"
            rules={[{ required: true, message: "Please select a specialty" }]}
            style={{ flex: 1, fontWeight: "500", fontSize: "16px" }}
          >
            <Select
              disabled={disabled}
              placeholder="Select Specialty"
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => {
                const searchText = input.toLowerCase();
                const optionText = (option?.children || '').toLowerCase();
                const optionValue = (option?.value || '').toLowerCase();
                return optionText.includes(searchText) || optionValue.includes(searchText);
              }}
            >
              <Select.Option value="Dermatology (Skin)">Dermatology (Skin)</Select.Option>
              <Select.Option value="Dentistry (Teeth)">Dentistry (Teeth)</Select.Option>
              <Select.Option value="Psychiatry (Mental, Emotional or Behavioral Disorders)">Psychiatry (Mental, Emotional or Behavioral Disorders)</Select.Option>
              <Select.Option value="Pediatrics and New Born (Child)">Pediatrics and New Born (Child)</Select.Option>
              <Select.Option value="Neurology (Brain & Nerves)">Neurology (Brain & Nerves)</Select.Option>
              <Select.Option value="Orthopedics (Bones)">Orthopedics (Bones)</Select.Option>
              <Select.Option value="Gynaecology and Infertility">Gynaecology and Infertility</Select.Option>
              <Select.Option value="Ear, Nose and Throat">Ear, Nose and Throat</Select.Option>
              <Select.Option value="Cardiology and Vascular Disease (Heart)">Cardiology and Vascular Disease (Heart)</Select.Option>
              <Select.Option value="Allergy and Immunology (Sensitivity and Immunity)">Allergy and Immunology (Sensitivity and Immunity)</Select.Option>
              <Select.Option value="Andrology and Male Infertility">Andrology and Male Infertility</Select.Option>
              <Select.Option value="Audiology">Audiology</Select.Option>
              <Select.Option value="Cardiology and Thoracic Surgery (Heart & Chest)">Cardiology and Thoracic Surgery (Heart & Chest)</Select.Option>
              <Select.Option value="Chest and Respiratory">Chest and Respiratory</Select.Option>
              <Select.Option value="Diabetes and Endocrinology">Diabetes and Endocrinology</Select.Option>
              <Select.Option value="Diagnostic Radiology (Scan Centers)">Diagnostic Radiology (Scan Centers)</Select.Option>
              <Select.Option value="Dietitian and Nutrition">Dietitian and Nutrition</Select.Option>
              <Select.Option value="Family Medicine">Family Medicine</Select.Option>
              <Select.Option value="Gastroenterology and Endoscopy">Gastroenterology and Endoscopy</Select.Option>
              <Select.Option value="General Practice">General Practice</Select.Option>
              <Select.Option value="General Surgery">General Surgery</Select.Option>
              <Select.Option value="Geriatrics (Old People Health)">Geriatrics (Old People Health)</Select.Option>
              <Select.Option value="Hematology">Hematology</Select.Option>
              <Select.Option value="Hepatology (Liver Doctor)">Hepatology (Liver Doctor)</Select.Option>
              <Select.Option value="Internal Medicine">Internal Medicine</Select.Option>
              <Select.Option value="Interventional Radiology">Interventional Radiology</Select.Option>
              <Select.Option value="IVF and Infertility">IVF and Infertility</Select.Option>
              <Select.Option value="Laboratories">Laboratories</Select.Option>
              <Select.Option value="Nephrology">Nephrology</Select.Option>
              <Select.Option value="Neurosurgery (Brain & Nerves Surgery)">Neurosurgery (Brain & Nerves Surgery)</Select.Option>
              <Select.Option value="Obesity and Laparoscopic Surgery">Obesity and Laparoscopic Surgery</Select.Option>
              <Select.Option value="Oncology (Tumor)">Oncology (Tumor)</Select.Option>
              <Select.Option value="Oncology Surgery (Tumor Surgery)">Oncology Surgery (Tumor Surgery)</Select.Option>
              <Select.Option value="Ophthalmology (Eyes)">Ophthalmology (Eyes)</Select.Option>
              <Select.Option value="Osteopathy (Osteopathic Medicine)">Osteopathy (Osteopathic Medicine)</Select.Option>
              <Select.Option value="Pain Management">Pain Management</Select.Option>
              <Select.Option value="Pediatric Surgery">Pediatric Surgery</Select.Option>
              <Select.Option value="Phoniatrics (Speech)">Phoniatrics (Speech)</Select.Option>
              <Select.Option value="Physiotherapy and Sport Injuries">Physiotherapy and Sport Injuries</Select.Option>
              <Select.Option value="Plastic Surgery">Plastic Surgery</Select.Option>
              <Select.Option value="Rheumatology">Rheumatology</Select.Option>
              <Select.Option value="Spinal Surgery">Spinal Surgery</Select.Option>
              <Select.Option value="Urology (Urinary System)">Urology (Urinary System)</Select.Option>
              <Select.Option value="Vascular Surgery (Arteries and Vein Surgery)">Vascular Surgery (Arteries and Vein Surgery)</Select.Option>
            </Select>
          </Form.Item>
        </div>

        <div style={{ display: "flex", gap: "8px", alignItems: "flex-end", flex: "1 1 calc(50% - 8px)", minWidth: "300px" }}>
          <Form.Item
            label="Medicine Name"
            name="medicine_name"
            style={{ flex: 1, fontWeight: "500", fontSize: "16px" }}
          >
            <Select
              placeholder="Enter Medicine Name"
              disabled={disabled}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label || '').toLowerCase().includes(input.toLowerCase())
              }
              onChange={(value) => {
                const selectedMedicine = MedicinesList.find(medicine => medicine.id === value);
                if (selectedMedicine) {
                  form.setFieldsValue({ dose: selectedMedicine.dose });
                }
              }}
            >
              {MedicinesList.map((Medicines) => (
                <Select.Option key={Medicines.id} value={Medicines.id} label={Medicines.name}>
                  {Medicines.name} ({Medicines.type ? Medicines.type : "No Type"})
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </div>

        {/* Row 2 */}
        <div style={{ display: "flex", gap: "8px", alignItems: "flex-end", flex: "1 1 calc(50% - 8px)", minWidth: "300px" }}>
          <Form.Item
            label="Dose"
            name="dose"
            style={{ flex: 1, fontWeight: "500", fontSize: "16px" }}
          >
            <InputNumber
              disabled={true}
              placeholder="Dose will auto-fill"
              className="no-arrows"
              style={{
                width: "100%",
                padding: "0",
                textAlign: "center",
                backgroundColor: "#f5f5f5",
              }}
            />
          </Form.Item>
        </div>

        <div style={{ display: "flex", gap: "8px", alignItems: "flex-end", flex: "1 1 calc(50% - 8px)", minWidth: "300px" }}>
          <Form.Item
            label="Quantity"
            name="quantity"
            style={{ flex: 1, fontWeight: "500", fontSize: "16px" }}
          >
            <InputNumber
              disabled={disabled}
              placeholder="Enter Quantity"
              className="no-arrows"
              style={{
                width: "100%",
                padding: "0",
                textAlign: "center",
              }}
            />
          </Form.Item>
        </div>

        {/* Row 3 */}
        <div style={{ display: "flex", gap: "8px", alignItems: "flex-end", flex: "1 1 calc(50% - 8px)", minWidth: "300px" }}>
          <Form.Item
            label="Quantity of Box"
            name="quantityOfBox"
            style={{ flex: 1, fontWeight: "500", fontSize: "16px" }}
          >
            <InputNumber
              disabled={disabled}
              placeholder="Enter quantityOfBox"
              className="no-arrows"
              style={{
                width: "100%",
                padding: "0",
                textAlign: "center",
              }}
            />
          </Form.Item>
        </div>

        <div style={{ display: "flex", gap: "8px", alignItems: "flex-end", flex: "1 1 calc(50% - 8px)", minWidth: "300px" }}>
          <Form.Item
            label="Amount of Dose"
            name="amountOfDose"
            style={{ flex: 1, fontWeight: "500", fontSize: "16px" }}
          >
            <Select
              disabled={disabled}
              placeholder="Select Amount of Dose"
              style={{ width: "100%" }}
            >
              <Select.Option value={0.5}>0.5 pill</Select.Option>
              <Select.Option value={1}>1 pill</Select.Option>
              <Select.Option value={1.5}>1.5 pills</Select.Option>
              <Select.Option value={2}>2 pills</Select.Option>
              <Select.Option value={2.5}>2.5 pills</Select.Option>
              <Select.Option value={3}>3 pills</Select.Option>
            </Select>
          </Form.Item>
        </div>

        {/* Row 4 - Start and End Date side by side */}
        <div style={{ display: "flex", gap: "8px", alignItems: "flex-end", flex: "1 1 calc(50% - 8px)", minWidth: "300px" }}>
          <Form.Item
            label="Start Date"
            name="start_date"
            style={{ flex: 1, fontWeight: "500", fontSize: "16px" }}
          >
            <DatePicker
              disabled={disabled}
              onOpenChange={(open) => {
                if (open) {
                  form.setFieldsValue({ start_date: null });
                }
              }}
              onChange={(date) => {
                // Reset both end date and quick selection when start date changes
                form.setFieldsValue({
                  end_date: null,
                  quick_end_date: null
                });
              }}
              disabledDate={(current) =>
                current && current < moment().add("day").startOf("day")
              }
              format="YYYY-MM-DD HH:mm:ss"
              showTime={{ format: 'HH:mm:ss' }}
              prefix={<img src="/assets/images/date.svg" alt="calendar icon" />}
              suffixIcon={null}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </div>

        <div style={{ display: "flex", gap: "8px", alignItems: "flex-end", flex: "1 1 calc(50% - 8px)", minWidth: "300px" }}>
          <Form.Item
            label="End Date"
            name="end_date"
            style={{ flex: 1, fontWeight: "500", fontSize: "16px" }}
          >
            <DatePicker
              disabled={disabled}
              showTime
              onOpenChange={(open) => {
                if (open) {
                  form.setFieldsValue({ end_date: null });
                }
              }}
              disabledDate={(current) => {
                const startDate = form.getFieldValue("start_date");
                const tomorrow = moment().add(1, "day").startOf("day");
                const minDate = startDate ? startDate : tomorrow;
                return current && current < minDate;
              }}
              format="YYYY-MM-DD HH:mm:ss"
              prefix={<img src="/assets/images/date.svg" alt="calendar icon" />}
              suffixIcon={null}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </div>

        <div style={{ display: "flex", gap: "8px", alignItems: "flex-end", width: "100%" }}>
          <Form.Item
            name="quick_end_date"
            style={{ flex: 1, fontWeight: "500", fontSize: "16px" }}
          >
            <Radio.Group
              disabled={disabled}
              onChange={(e) => {
                const { start_date } = form.getFieldsValue(); // ✅ gets the latest snapshot of all fields
                console.log(start_date);
                if (!start_date) {
                  message.warning("Please select a start date first");
                  return;
                }

                const startMoment = moment(start_date?.$d || start_date);
                let endDate;
                switch (e.target.value) {
                  case "5days":
                    endDate = startMoment.clone().add(5, "days").startOf("day");
                    break;
                  case "7days":
                    endDate = startMoment.clone().add(7, "days").startOf("day");
                    break;
                  case "10days":
                    endDate = startMoment.clone().add(10, "days").startOf("day");
                    break;
                  case "14days":
                    endDate = startMoment.clone().add(14, "days").startOf("day");
                    break;
                  case "month":
                    endDate = startMoment.clone().add(1, "month").startOf("day");
                    break;
                  default:
                    return;
                }

                form.setFieldsValue({ end_date: endDate });
              }}


            >
              <Radio value="5days">5 Days</Radio>
              <Radio value="7days">7 Days</Radio>
              <Radio value="10days">10 Days</Radio>
              <Radio value="14days">14 Days</Radio>
              <Radio value="month">Month</Radio>
            </Radio.Group>
          </Form.Item>
        </div>

        {/* Row 5 */}
        <div style={{ display: "flex", gap: "8px", alignItems: "flex-end", flex: "1 1 calc(50% - 8px)", minWidth: "300px" }}>
          <Form.Item
            label="Direction of use"
            name="frequency"
            style={{ flex: 1, fontWeight: "500", fontSize: "16px" }}
          >
            <Radio.Group disabled={disabled}>
              <Radio value={4}>4 Hours</Radio>
              <Radio value={6}>6 Hours</Radio>
              <Radio value={8}>8 Hours</Radio>
              <Radio value={12}>12 Hours</Radio>
              <Radio value={24}>24 Hours</Radio>
            </Radio.Group>
          </Form.Item>
        </div>

        <div style={{ display: "flex", gap: "8px", alignItems: "flex-end", width: "100%" }}>
          <Form.Item
            label="Time To Take"
            name="timeToTake"
            style={{ flex: 1, fontWeight: "500", fontSize: "16px" }}
          >
            <Radio.Group disabled={disabled}>
              <Radio value="Before Food">Before Food</Radio>
              <Radio value="After Food">After Food</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item
            label="Select Unit"
            name="unit"
            style={{ flex: 1, fontWeight: "500", fontSize: "16px" }}
          >
            <Radio.Group disabled={disabled}>
              <Radio value="Tablet">Tablet</Radio>
              <Radio value="Blister">Blister</Radio>
              <Radio value="Box">Box</Radio>
            </Radio.Group>
          </Form.Item>
        </div>
      </div>

      <Form.Item
        label="Comments"
        name="comments"
        style={{ fontWeight: "500", fontSize: "16px" }}
      >
        <TextArea
          rows={4}
          placeholder="Enter any comments"
          disabled={disabled}
        />
      </Form.Item>

      {additionalMeds.length > 0 && (
        <div
          style={{
            marginTop: "20px",
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            columnGap: "2%",
          }}
        >
          {additionalMeds.map((med) => (
            <div
              key={med.frequency + 1}
              style={{
                display: "flex",
                flexDirection: "column",
                marginBottom: "10px",
              }}
            >
              <div>
                <strong>Medicine Name:</strong>{" "}
                {med.medicine_name
                  ? MedicinesList.find(
                    (medicine) => medicine.id === med.medicine_name
                  )?.name || "Null"
                  : "Null"}
              </div>
              <div>
                <strong>Dose:</strong> {med.dose}
              </div>
              <div>
                <strong>Frequency:</strong> {med.frequency} Hour(s)
              </div>
              <Button
                style={{ color: "red", padding: "5px 10px", marginTop: "10px" }}
                onClick={() => removeMedication(med.id)}
              >
                Delete
              </Button>
            </div>
          ))}
        </div>
      )}

      {disabled ? null : (
        <div
          style={{
            display: "flex",
            flexDirection: isFullWidth ? "column" : "row",
            justifyContent: "space-between",
            marginTop: "20px",
            alignItems: isFullWidth ? "stretch" : "center",
            flexWrap: "wrap",
            gap: "16px"
          }}
        >
          <div style={{
            display: "flex",
            alignItems: "center",
            flex: isFullWidth ? "auto" : "1",
            width: isFullWidth ? "100%" : "auto",
            justifyContent: isFullWidth ? "center" : "flex-start"
          }}>
            <Form.Item
              name="prescriptionImage"
              style={{ marginBottom: 0, width: isFullWidth ? "100%" : "auto" }}

            >
              <S3UploadButton
                fullWidth={isFullWidth}
                name="Add Attachments"
                maxUploads={1}
                initValue={data?.prescriptionImage || []}
                onChange={(url) => {
                  if (url) {
                    form.setFieldsValue({ prescriptionImage: url });
                  } else {
                    form.setFieldsValue({ prescriptionImage: null });
                  }
                }}
                style={{
                  width: isFullWidth ? "100%" : "auto",
                  // display: "block"
                }}
              />
            </Form.Item>

            {fileList.length > 0 && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  marginLeft: "10px"
                }}
              >
                {fileList[0].name.length > 5
                  ? `${fileList[0].name.substring(0, 15)}...`
                  : fileList[0].name}
                <Button
                  type="link"
                  danger
                  onClick={handleFileRemove}
                  style={{ padding: 0 }}
                >
                  Delete
                </Button>
              </div>
            )}
          </div>

          {PatchMethod ? null : (
            <div style={{
              display: "flex",
              justifyContent: "center",
              flex: isFullWidth ? "auto" : "1",
              width: isFullWidth ? "100%" : "auto"
            }}>
              <Button
                type="default"
                onClick={addAdditionalMedication}
                style={{
                  borderRadius: "4px",
                  padding: "20px 30px",
                  border: "1px solid #3371EB",
                  color: "#3371EB",
                  width: isFullWidth ? "100%" : "auto"
                }}
              >
                Additional Medication
              </Button>
            </div>
          )}

          <div style={{
            display: "flex",
            justifyContent: isFullWidth ? "center" : "flex-end",
            flex: isFullWidth ? "auto" : "1",
            width: isFullWidth ? "100%" : "auto"
          }}>
            <Button
              type="primary"
              htmlType="submit"
              style={{
                background: "#1677ff",
                borderRadius: "4px",
                padding: "20px 30px",
                width: isFullWidth ? "100%" : "auto"
              }}
            >
              Save
            </Button>
          </div>
        </div>
      )}
    </Form>
  );
}

export default Prescribed;
